import { format } from "date-fns";
import React, { useContext, useEffect } from "react";
import { ResumeContext } from "../../../contexts/resumeContext";
import "./styles.css";

export default ({ info }) => {
  const { setColorOptions, activeColor, setActiveColor, resumeHeadings, setImgSupported} =
    useContext(ResumeContext);

  useEffect(() => {
    setColorOptions(["#577BE5", '#615648', '#63AFB4', '#DCC063']);
    setActiveColor("#577BE5");
    setImgSupported(true)
  }, []);

  const {
    personalDetails,
    educationDetails,
    professionalDetails,
    skills,
    social,
    misc,
  } = info;

  const education = Object.values(educationDetails || {});
  const work = Object.values(professionalDetails || {});
  const userSkills = Object.values(skills || {});
  const socialLinks = Object.values(social || {});
  const { courses, hobbies, languages, references, internships, activities, projects } =
    misc || {};

  return (
    <div className="creative">
      <div className="head" style={{ background: activeColor }}>
        <div className="name">
          {personalDetails?.firstName?.trim()}{" "}
          {personalDetails?.lastName?.trim()}
        </div>
        <p className="title">{personalDetails?.jobTitle}</p>
      </div>
      <div className="body">
        <div className="row">
          <div className="col" style={{borderColor: activeColor}}>
            <div className="contact-section" style={{borderColor: activeColor}}>
              {personalDetails?.userImage ? (
                <img className="avatar" src={personalDetails?.userImage} />
              ) : (
                <div className="avatar" style={{background: activeColor}}>
                  {personalDetails?.firstName?.[0]}
                  {personalDetails?.lastName?.[0]}
                </div>
              )}
              <div style={{ width: "75%", margin: "auto" }}>
                {personalDetails?.email && (
                  <>
                    <span style={{color: activeColor}}>Email</span>
                    <p>
                      <a href={`mailto:${personalDetails?.email?.trim()}`}>
                        {personalDetails?.email?.trim()}
                      </a>
                    </p>
                  </>
                )}
                {personalDetails?.phone && (
                  <>
                    <span style={{color: activeColor}}>Phone</span>
                    <p>
                      <a href={`tel:${personalDetails?.phone?.trim()}`}>
                        {personalDetails?.phone?.trim()}
                      </a>
                    </p>
                  </>
                )}
                {(personalDetails?.address?.trim() ||
                  personalDetails?.postalCode?.trim()) && (
                  <>
                    <span style={{color: activeColor}}>Address</span>
                    <p>
                      {personalDetails?.address?.trim()}
                      {personalDetails?.postalCode?.trim() && " - "}
                      {personalDetails?.postalCode?.trim()}
                    </p>
                  </>
                )}
                {socialLinks.map((link, ix) =>
                  link.link !== "" ? (
                    <>
                      <span style={{color: activeColor}}>{link.label}</span>
                      <p>
                        <a href={link.link} target="_blank">
                          {link.link}
                        </a>
                      </p>
                    </>
                  ) : null
                )}
              </div>
            </div>
            {!!userSkills?.length && <div className="section skills">
              <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.SK}</h2>
              <br />
              {userSkills.map((skill, ix) => (
                <span className="skill" style={{borderColor: activeColor}} key={skill + ix}>
                  {skill}
                </span>
              ))}
            </div>}
            {!!references?.length && (
              <div className="section" id="reference">
                <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.REF}</h2>
                {references?.map((ref, ix) => (
                  <div className="sub-section">
                    <h3 className="sub-section-heading">{ref.name}</h3>
                    {ref.institution && <p>{ref.institution}</p>}
                    <p>
                      {ref.email}{" "}
                      {ref.phone && <> &nbsp; | &nbsp; {ref.phone}</>}
                    </p>
                  </div>
                ))}
              </div>
            )}
            {!!hobbies?.length && (
              <div className="section">
                <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.HOB}</h2>
                <p className="m-0">{hobbies}</p>
              </div>
            )}
            {!!languages?.length && (
              <div className="section">
                <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.LAN}</h2>
                <p className="m-0">{languages}</p>
              </div>
            )}
          </div>
          <div style={{ width: "62%", paddingTop: "2em" }}>
            {personalDetails?.summary && <div className="section">
              <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.SUM}</h2>
              <p
                className="m-0"
                dangerouslySetInnerHTML={{ __html: personalDetails?.summary }}
              ></p>
            </div>}
            {!!education?.length && <div className="section education">
              <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.AD}</h2>
              {education?.map((ed, ix) => (
                <div className="education-sub-section row">
                  <span className="date">
                    {ed.startDate && (
                      <>{format(new Date(ed.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {ed.endDate && (
                      <>- {format(new Date(ed.endDate), "MMM yyyy")}</>
                    )}
                  </span>
                  <div style={{ flex: 0.7 }}>
                    <h3 className="education-title" style={{color: activeColor}}>{ed.degree}</h3>
                    <b>
                      {ed.institute}
                      {ed.location && <>, {ed.location}</>}
                    </b>
                    <div dangerouslySetInnerHTML={{ __html: ed.description }} />
                  </div>
                </div>
              ))}
            </div>}
            {!!projects?.length && <div className="section education">
              <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.PRO}</h2>
              {projects?.map((pro, ix) => (
                <div className="education-sub-section row">
                  <span className="date">
                    {pro.startDate && (
                      <>{format(new Date(pro.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {pro.endDate && (
                      <>- {format(new Date(pro.endDate), "MMM yyyy")}</>
                    )}
                  </span>
                  <div style={{ flex: 0.7 }}>
                    <h3 className="education-title" style={{color: activeColor}}>{pro.title}</h3>
                    <b>
                      {pro.company}
                    </b>
                    <div dangerouslySetInnerHTML={{ __html: pro.description }} />
                  </div>
                </div>
              ))}
            </div>}
            {!!work?.length && <div className="section work-ex">
              <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.WE}</h2>
              {work.map((exp, ix) => (
                <div className="sub-section">
                  <b>{exp.jobTitle}</b>, <span>{exp.company}</span>
                  <p>
                    {exp.startDate && (
                      <>{format(new Date(exp.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {exp.endDate && (
                     <>- {exp.endDate === "Present" ? "Present" : format(new Date(exp.endDate), "MMM yyyy")}</>
                    )}
                    <span style={{ float: "right" }}>{exp.location}</span>
                  </p>
                  <div
                    className="apex__subsection_text"
                    dangerouslySetInnerHTML={{ __html: exp.description }}
                  />
                </div>
              ))}
            </div>}
            {!!internships?.length && (
              <div className="section work-ex">
                <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.INT}</h2>
                {internships.map((intern, ix) => (
                  <div className="sub-section">
                    <b>{intern.jobTitle}</b>, <span>{intern.company}</span>
                    <p>
                      {intern.startDate && (
                        <>{format(new Date(intern.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {intern.endDate && (
                        <>- {format(new Date(intern.endDate), "MMM yyyy")}</>
                      )}
                      <span style={{ float: "right" }}>{intern.location}</span>
                    </p>
                    <div
                      dangerouslySetInnerHTML={{ __html: intern.description }}
                    />
                  </div>
                ))}
              </div>
            )}
            {!!courses?.length && (
              <div className="section education">
                <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.CR}</h2>
                {courses?.map((course, ix) => (
                  <div className="education-sub-section row">
                    <span className="date">
                      {course.startDate && (
                        <>{format(new Date(course.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {course.endDate && (
                        <>- {format(new Date(course.endDate), "MMM yyyy")}</>
                      )}
                    </span>
                    <div style={{ flex: 0.7 }}>
                      <h3 className="education-title" style={{color: activeColor}}>{course.name}</h3>
                      <b>{course.institution}</b>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {!!activities?.length && (
              <div className="section education">
                <h2 className="heading" style={{background: activeColor}}>{resumeHeadings?.ACT}</h2>
                {activities?.map((activity, ix) => (
                  <div
                    className="education-sub-section row"
                    key={"activity" + ix}
                  >
                    <span className="date">
                      {activity.startDate && (
                        <>{format(new Date(activity.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {activity.endDate && (
                        <>- {format(new Date(activity.endDate), "MMM yyyy")}</>
                      )}
                    </span>
                    <div style={{ flex: 0.7 }}>
                      <h3 className="education-title" style={{color: activeColor}}>{activity.title}</h3>
                      <b>
                        {activity.institution}
                        {activity.location && <>, {activity.location}</>}
                      </b>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: activity.description,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
